var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconRightArrowComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-right_arrow").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M13.8047 7.5286L8.37377 2.09763C8.2436 1.96746 8.03254 1.96746 7.90237 2.09763L7.43096 2.56904C7.30079 2.69921 7.30079 2.91027 7.43096 3.04044L11.7239 7.33333H2.33333C2.14924 7.33333 2 7.48257 2 7.66667V8.33333C2 8.51743 2.14924 8.66667 2.33333 8.66667H11.7239L7.43096 12.9596C7.30079 13.0897 7.30079 13.3008 7.43096 13.431L7.90237 13.9024C8.03254 14.0325 8.2436 14.0325 8.37377 13.9024L13.8047 8.4714C14.0651 8.21106 14.0651 7.78895 13.8047 7.5286Z", fillOpacity: "1" }));
}
var IconRightArrow = React.forwardRef(IconRightArrowComponent);
export default IconRightArrow;
